import {MeshButtonDBType, MeshButtonType} from "../../components/annotations/ts/ButtonsTypes";
import * as THREE from "three";

export const  MeshButtonsDB: Array<MeshButtonDBType> = [
    {
        button_id: 'HKT_P001',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true
    },
    {
        button_id: 'HKT_P013',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        // outlinerColor: new THREE.Color(0x0000FF),
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
    {
        button_id: 'HB2_P023',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        //outlinerColor: new THREE.Color(0x0000FF),
    },
    {
        button_id: 'HLR_P012',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        //outlinerColor: new THREE.Color(0x0000FF),
    },
    {
        button_id: 'HKT_P034',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        //outlinerColor: new THREE.Color(0x0000FF),
    },
    {
        button_id: 'HLR_P019',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        //outlinerColor: new THREE.Color(0x0000FF),
    },
    {
        button_id: 'HLR_P030',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        //outlinerColor: new THREE.Color(0x0000FF),
    },
    {
        button_id: 'HLR_P032',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        //outlinerColor: new THREE.Color(0x0000FF),
    },
    {
        button_id: 'SWK_P024',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        //outlinerColor: new THREE.Color(0x0000FF),
    },
    {
        button_id: 'SWK_P025',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        //outlinerColor: new THREE.Color(0x0000FF),
    },
    {
        button_id: 'HB2_P027',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        //outlinerColor: new THREE.Color(0x0000FF),
    },
    {
        button_id: 'HPD_P016',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        //outlinerColor: new THREE.Color(0x0000FF),
    },
    // {
    //     button_id: 'HKT_V003',
    //     meshButtonType: MeshButtonType.AnimatedMeshButton,
    //     pauseImagePath:'/images/project_Images/MicrowaveBtnPause.jpg',
    // },
    {
        button_id: 'HKT_P004',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true
    },
    // {
    //     button_id: 'HKT_P013',
    //     meshButtonType: MeshButtonType.BasicMeshButton
    // },
    {
        button_id: 'HLR_V009_BTN',
        meshButtonType: MeshButtonType.BasicMeshButton,
    },
    {
        button_id: 'SWK_V007_BTN',
        meshButtonType: MeshButtonType.BasicMeshButton,
    },
      {
        button_id: 'GBG_V008_BTN',
        meshButtonType: MeshButtonType.BasicMeshButton,
    },
    {
        button_id: 'HB2_V011_BTN',
        meshButtonType: MeshButtonType.BasicMeshButton,
    },
    // {
    //     button_id: 'HPD_P016',
    //     meshButtonType: MeshButtonType.BasicMeshButton,
    // },
    {
        button_id: 'HB2_P027',
        meshButtonType: MeshButtonType.BasicMeshButton,
    },
    {
        button_id: 'HB2_P023',
        meshButtonType: MeshButtonType.BasicMeshButton,
    },
    {
        button_id: 'HLR_P032',
        meshButtonType: MeshButtonType.BasicMeshButton,
    },
    {
        button_id: 'HLR_P030',
        meshButtonType: MeshButtonType.BasicMeshButton,
    },
    {
        button_id: 'HLR_P019',
        meshButtonType: MeshButtonType.BasicMeshButton,
    },
    {
        button_id: 'HKT_P034',
        meshButtonType: MeshButtonType.BasicMeshButton,
    },
    {
        button_id: 'HLR_T021',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
    {
        button_id: 'GFG_P018',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
    {
        button_id: 'HKT_P026',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
    {
        button_id: 'HKT_T031',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
    {
        button_id: 'HKT_P029',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
 {
        button_id: 'HPD_T015',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
    {
        button_id: 'HPD_P017',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
    {
        button_id: 'HLR_P006',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        // outlinerColor: new THREE.Color(0xFFFFFF),
    },
    {
        button_id: 'HHL_P005',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
    {
        button_id: 'HHL_P028',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
 {
        button_id: 'HB1_P014',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        outlinerColor: new THREE.Color(0xFFFF00),
    },
    {
        button_id: 'HB2_T022',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        outlinerColor: new THREE.Color(0xFFFF00),
    },
    {
        button_id: 'HKT_P036',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
    {
        button_id: 'HKT_P037',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
    {
        button_id: 'HHL_P038',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
    {
        button_id: 'HKT_P039',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
    {
        button_id: 'HLR_P040',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
    {
        button_id: 'HKT_P041',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
    {
        button_id: 'HLR_P042',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
    {
        button_id: 'HKT_P043',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
    {
        button_id: 'HKT_P044',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
    {
        button_id: 'HKT_P045',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
    {
        button_id: 'HB3_P053',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
    {
        button_id: 'HB3_P053',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
{
        button_id: 'HBT_P054',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
{
        button_id: 'HKT_P055',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
{
        button_id: 'HLR_P057',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
{
        button_id: 'GBG_P058_BTN',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
{
        button_id: 'HB4_P044',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
    {
        button_id: 'HB1_P039',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
    {
        button_id: 'HKT_P060',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
{
        button_id: 'HLR_P062',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
    {
        button_id: 'HB4_P064',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
{
        button_id: 'GRG_P063',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        outlinerColor: new THREE.Color(0xFF0000),
        edgeStrength: 10.0,
    },
    {
        button_id: 'GHI_P065',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
    {
        button_id: 'HLR_P066',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
    {
        button_id: 'GFG_T068',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
    {
        button_id: 'GBG_P069',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
    {
        button_id: 'GFG_T070',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
     {
        button_id: 'HTO_P077',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        outlinerColor: new THREE.Color(0xFFFF00),
    },
    {
        button_id: 'HKT_P073',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
    {
        button_id: 'HPD_P035',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
    {
        button_id: 'GRG_P078',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
    {
        button_id: 'SWK_T075',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        outlinerColor: new THREE.Color(0xFFFF00),
    },
    {
        button_id: 'HB3_P079',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
    {
        button_id: 'GRG_P083',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
    {
        button_id: 'GHI_P085',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
    {
        button_id: 'HHL_P076',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        outlinerColor: new THREE.Color(0xFFFF00),
    },
    {
        // Though it's an audio, it is added as a regular meshubutton
        button_id: 'HKT_P089',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
    {
        button_id: 'HKT_P090',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        outlinerColor: new THREE.Color(0xFFFF00),
    },
    {
        button_id: 'GHI_P091',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        outlinerColor: new THREE.Color(0xFFFF00),
    },
// {
    //     button_id: '',
    //     meshButtonType: MeshButtonType.BasicMeshButton,
    //     useOutliner: true,
    //     outlinerColor: new THREE.Color(0xFFFFFF),
    // },

]
